import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH,APPLICATION_MODE_NEW } from "../../../app/constants";
import { Button } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";

export const MainAgentNSLicenceConfirmation = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();

  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;
  
  const handleNext = (isLicenceAvailable) => () => {
    if(isLicenceAvailable) {
      dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CURRENT_NS_LICENCE_NUMBER}`));
    } else { 
      dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_APPLICATION_REVIEW}`));
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row bottomMarginLarge">
        <div className="col-xs-12 col-lg-8">
          <h1>Are you currently a Mortgage Broker in the Province of Nova Scotia?</h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-2">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
